export default __webpack_public_path__ + "static/media/card-pay-icon.38d071d6.svg";